// const baseURL = 'https://localhost:44379/api/';
 const baseURL = 'https://api.estockgov.com/api/';

export const LOGIN_URL = `${baseURL}Account/login`;
export const CLIENT_URL = `${baseURL}Masters/getclients`;
export const GET_CLIENT_BY_ID = `${baseURL}Masters/getclientbyid`;
export const ADD_UPDATE_CLIENT = `${baseURL}Masters/addeditclient`;
export const DESIGNATION_URL = `${baseURL}Masters/getdesignations`;
export const GET_DESIGNATION_BY_ID = `${baseURL}Masters/getdesignationbyid`;
export const ADD_UPDATE_DESIGNATION = `${baseURL}Masters/addeditdesignation`;
export const OFFICE_URL = `${baseURL}Masters/getoffices`;
export const GET_OFFICE_BY_ID = `${baseURL}Masters/getofficebyid`;
export const ADD_UPDATE_OFFICE = `${baseURL}Masters/addeditoffice`;
export const ITEM_CATEGORY_URL = `${baseURL}Masters/getitemcategories`;
export const GET_ITEM_CATEGORY_BY_ID = `${baseURL}Masters/getitemcategorybyid`;
export const ADD_UPDATE_ITEM_CATEGORY = `${baseURL}Masters/addedititemcategory`;
export const ITEM_URL = `${baseURL}Masters/getitems`;
export const GET_ITEM_BY_ID = `${baseURL}Masters/getitembyid`;
export const ADD_UPDATE_ITEM = `${baseURL}Masters/addedititem`;
export const USERS_URL = `${baseURL}Masters/getusers`;
export const GET_USER_BY_ID = `${baseURL}Masters/getuserbyid`;
export const GET_USERS_BY_DESIGNATION_ID = `${baseURL}Masters/getusersbydesignationid`;
export const ADD_UPDATE_USER = `${baseURL}Masters/addedituser`;
export const UPDATE_PASSWORD = `${baseURL}Masters/updatepassword`;
export const VENDOR_URL = `${baseURL}Masters/getvendos`;
export const GET_VENDOR_BY_ID = `${baseURL}Masters/getvendorbyid`;
export const UNIT_URL = `${baseURL}Masters/getunits`;
export const GET_UNIT_BY_ID = `${baseURL}Masters/getunitbyid`;
export const ADD_UPDATE_UNIT = `${baseURL}Masters/addeditunit`;
export const GET_UNIT_BY_ITEM = `${baseURL}Masters/getunitofitem`;
export const ADD_UPDATE_VENDOR = `${baseURL}Masters/addeditvendor`;
export const ITEM_DEMAND_BY_SEARCH_URL = `${baseURL}Stock/getitemdemands`;
export const ADD_ITEM_DEMAND = `${baseURL}Stock/additemdemand`;
export const ADD_ITEM_DETAILS_DEMAND = `${baseURL}Stock/additemdemanddetails`;
export const DELETE_ITEM_DETAILS_DEMAND = `${baseURL}Stock/deleteitemdemanddetails`;
export const ITEM_RECEIPT_BY_SEARCH_URL = `${baseURL}Stock/getitemreceipts`;
export const GET_ITEM_RECEIPT_DETAILS = `${baseURL}Stock/getitemreceiptdetails`;
export const DELETE_ITEM_RECEIPT = `${baseURL}Stock/deleteitemreceipt`;
export const ADD_ITEM_RECEIPT = `${baseURL}Stock/additemreceipts`;
export const ITEM_DISTRIBUTION_SEARCH_URL = `${baseURL}Stock/getitemdistribution`;
export const GET_ITEM_DISTRIBUTION_BY_ID = `${baseURL}Stock/getitemdistributionbyid`;
export const ADD_UPDATE_ITEM_DISTRIBUTION = `${baseURL}Stock/addedititemdistribution`;

export const GET_ITEM_DEMAND_REPORT = `${baseURL}Stock/getitemdemandsreport`;
export const GET_ITEM_RECEIPT_REPORT = `${baseURL}Stock/getitemreceiptreport`;
export const GET_ITEM_DISTRIBUTION_REPORT = `${baseURL}Stock/getitemdistributionreport`;

export default LOGIN_URL;